module.exports = __webpack_public_path__ + "img/logo.57f12b53.png";